import migrationService from '../../services/migrationService';

// Synchronous guard so only one migration request runs (state.loading updates are async/batched)
let migrationRequestInFlight = false;
let currentLevelRequestInFlight = false;
let eeSotRequestInFlight = false;
let devTipRotationRequestInFlight = false;
let scheduleWallClockRequestInFlight = false;
let kssScheduleTimesRequestInFlight = false;
let featureMigrateRequestInFlight = false;
let tenantRolesRequestInFlight = false;

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null,
    dryRunResults: null,
    migrationResults: null,
    // Current level migration (separate flow)
    currentLevelLoading: false,
    currentLevelError: null,
    currentLevelDryRunResults: null,
    currentLevelMigrationResults: null,
    eeSotLoading: false,
    eeSotError: null,
    eeSotDryRunResults: null,
    eeSotMigrationResults: null,
    // Dev tip dimension rotation migration
    devTipRotationLoading: false,
    devTipRotationError: null,
    devTipRotationDryRunResults: null,
    devTipRotationMigrationResults: null,
    // Schedule UTC → wall-clock migration (schemas)
    scheduleWallClockLoading: false,
    scheduleWallClockError: null,
    scheduleWallClockDryRunResults: null,
    scheduleWallClockMigrationResults: null,
    // KSS series schedule times UTC → wall-clock
    kssScheduleTimesLoading: false,
    kssScheduleTimesError: null,
    kssScheduleTimesDryRunResults: null,
    kssScheduleTimesMigrationResults: null,
    // Features collection (legacy → flat docs)
    featureMigrateLoading: false,
    featureMigrateError: null,
    featureMigrateDryRunResults: null,
    featureMigrateApplyResults: null,
    // Tenant roles migration (legacy config → User.roles)
    tenantRolesLoading: false,
    tenantRolesError: null,
    tenantRolesDryRunResults: null,
    tenantRolesMigrationResults: null,
  },

  mutations: {
    SET_LOADING(state, isLoading) {
      state.loading = isLoading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DRY_RUN_RESULTS(state, results) {
      state.dryRunResults = results;
    },
    SET_MIGRATION_RESULTS(state, results) {
      state.migrationResults = results;
    },
    CLEAR_RESULTS(state) {
      state.dryRunResults = null;
      state.migrationResults = null;
      state.error = null;
    },
    SET_CURRENT_LEVEL_LOADING(state, isLoading) {
      state.currentLevelLoading = isLoading;
    },
    SET_CURRENT_LEVEL_ERROR(state, error) {
      state.currentLevelError = error;
    },
    SET_CURRENT_LEVEL_DRY_RUN_RESULTS(state, results) {
      state.currentLevelDryRunResults = results;
    },
    SET_CURRENT_LEVEL_MIGRATION_RESULTS(state, results) {
      state.currentLevelMigrationResults = results;
    },
    CLEAR_CURRENT_LEVEL_RESULTS(state) {
      state.currentLevelDryRunResults = null;
      state.currentLevelMigrationResults = null;
      state.currentLevelError = null;
    },
    SET_EE_SOT_LOADING(state, isLoading) {
      state.eeSotLoading = isLoading;
    },
    SET_EE_SOT_ERROR(state, error) {
      state.eeSotError = error;
    },
    SET_EE_SOT_DRY_RUN_RESULTS(state, results) {
      state.eeSotDryRunResults = results;
    },
    SET_EE_SOT_MIGRATION_RESULTS(state, results) {
      state.eeSotMigrationResults = results;
    },
    CLEAR_EE_SOT_RESULTS(state) {
      state.eeSotDryRunResults = null;
      state.eeSotMigrationResults = null;
      state.eeSotError = null;
    },
    SET_DEV_TIP_ROTATION_LOADING(state, isLoading) {
      state.devTipRotationLoading = isLoading;
    },
    SET_DEV_TIP_ROTATION_ERROR(state, error) {
      state.devTipRotationError = error;
    },
    SET_DEV_TIP_ROTATION_DRY_RUN_RESULTS(state, results) {
      state.devTipRotationDryRunResults = results;
    },
    SET_DEV_TIP_ROTATION_MIGRATION_RESULTS(state, results) {
      state.devTipRotationMigrationResults = results;
    },
    CLEAR_DEV_TIP_ROTATION_RESULTS(state) {
      state.devTipRotationDryRunResults = null;
      state.devTipRotationMigrationResults = null;
      state.devTipRotationError = null;
    },
    SET_SCHEDULE_WALL_CLOCK_LOADING(state, isLoading) {
      state.scheduleWallClockLoading = isLoading;
    },
    SET_SCHEDULE_WALL_CLOCK_ERROR(state, error) {
      state.scheduleWallClockError = error;
    },
    SET_SCHEDULE_WALL_CLOCK_DRY_RUN_RESULTS(state, results) {
      state.scheduleWallClockDryRunResults = results;
    },
    SET_SCHEDULE_WALL_CLOCK_MIGRATION_RESULTS(state, results) {
      state.scheduleWallClockMigrationResults = results;
    },
    CLEAR_SCHEDULE_WALL_CLOCK_RESULTS(state) {
      state.scheduleWallClockDryRunResults = null;
      state.scheduleWallClockMigrationResults = null;
      state.scheduleWallClockError = null;
    },
    SET_KSS_SCHEDULE_TIMES_LOADING(state, isLoading) {
      state.kssScheduleTimesLoading = isLoading;
    },
    SET_KSS_SCHEDULE_TIMES_ERROR(state, error) {
      state.kssScheduleTimesError = error;
    },
    SET_KSS_SCHEDULE_TIMES_DRY_RUN_RESULTS(state, results) {
      state.kssScheduleTimesDryRunResults = results;
    },
    SET_KSS_SCHEDULE_TIMES_MIGRATION_RESULTS(state, results) {
      state.kssScheduleTimesMigrationResults = results;
    },
    CLEAR_KSS_SCHEDULE_TIMES_RESULTS(state) {
      state.kssScheduleTimesDryRunResults = null;
      state.kssScheduleTimesMigrationResults = null;
      state.kssScheduleTimesError = null;
    },
    SET_FEATURE_MIGRATE_LOADING(state, isLoading) {
      state.featureMigrateLoading = isLoading;
    },
    SET_FEATURE_MIGRATE_ERROR(state, error) {
      state.featureMigrateError = error;
    },
    SET_FEATURE_MIGRATE_DRY_RUN_RESULTS(state, results) {
      state.featureMigrateDryRunResults = results;
    },
    SET_FEATURE_MIGRATE_APPLY_RESULTS(state, results) {
      state.featureMigrateApplyResults = results;
    },
    CLEAR_FEATURE_MIGRATE_RESULTS(state) {
      state.featureMigrateDryRunResults = null;
      state.featureMigrateApplyResults = null;
      state.featureMigrateError = null;
    },
    SET_TENANT_ROLES_LOADING(state, isLoading) {
      state.tenantRolesLoading = isLoading;
    },
    SET_TENANT_ROLES_ERROR(state, error) {
      state.tenantRolesError = error;
    },
    SET_TENANT_ROLES_DRY_RUN_RESULTS(state, results) {
      state.tenantRolesDryRunResults = results;
    },
    SET_TENANT_ROLES_MIGRATION_RESULTS(state, results) {
      state.tenantRolesMigrationResults = results;
    },
    CLEAR_TENANT_ROLES_RESULTS(state) {
      state.tenantRolesDryRunResults = null;
      state.tenantRolesMigrationResults = null;
      state.tenantRolesError = null;
    },
  },

  actions: {
    /**
     * Run a dry-run migration to preview what will be migrated
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug for single-tenant migration
     */
    async runDryRun({ commit }, tenantSlug = null) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);
      commit('CLEAR_RESULTS');

      try {
        const response = await migrationService.runMigrationDryRun(tenantSlug);
        // Backend returns { success, message, data:
        //  { totalSchemas, migrated, skipped, errors, errorDetails } }
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        let errors = [];
        if (Array.isArray(payload.errorDetails)) errors = payload.errorDetails;
        else if (Array.isArray(payload.errors)) errors = payload.errors;
        const result = {
          total: payload.totalSchemas ?? 0,
          toMigrate: payload.migrated ?? 0,
          alreadyMigrated: payload.skipped ?? 0,
          errors,
          ...(payload.tenantRoles && { tenantRoles: payload.tenantRoles }),
        };
        commit('SET_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Failed to run dry-run migration';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    /**
     * Run the actual migration
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug for single-tenant migration
     */
    async runMigration({ commit, state }, tenantSlug = null) {
      if (migrationRequestInFlight) {
        return state.migrationResults
          || {
            total: 0,
            migrated: 0,
            skipped: 0,
            errors: [],
          };
      }
      migrationRequestInFlight = true;
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const response = await migrationService.runMigration(tenantSlug);
        // Backend returns { success, message, data:
        //  { totalSchemas, migrated, skipped, errors, errorDetails } }
        // Support nested (response.data.data), top-level (response.data),
        //  and double-wrapped (response.data.data.data)
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        let errors = [];
        if (Array.isArray(payload.errorDetails)) errors = payload.errorDetails;
        else if (Array.isArray(payload.errors)) errors = payload.errors;
        let result = {
          total: payload.totalSchemas ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors,
          ...(payload.tenantRoles && { tenantRoles: payload.tenantRoles }),
        };
        // If response had no counts (e.g. proxy/cache returned empty)
        //  but we have dry run results, use those
        const emptyResponse = result.total === 0 && result.migrated === 0 && result.skipped === 0;
        if (emptyResponse && state.dryRunResults) {
          result = {
            total: state.dryRunResults.total ?? 0,
            migrated: state.dryRunResults.toMigrate ?? 0,
            skipped: state.dryRunResults.alreadyMigrated ?? 0,
            errors: state.dryRunResults.errors ?? [],
          };
        }
        commit('SET_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || 'Failed to run migration';
        commit('SET_ERROR', errorMessage);
        throw error;
      } finally {
        migrationRequestInFlight = false;
        commit('SET_LOADING', false);
      }
    },

    /**
     * Clear all results
     */
    clearResults({ commit }) {
      commit('CLEAR_RESULTS');
    },

    /**
     * Run current level migration dry run (preview only)
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug
     */
    async runCurrentLevelDryRun({ commit }, tenantSlug = null) {
      commit('SET_CURRENT_LEVEL_LOADING', true);
      commit('SET_CURRENT_LEVEL_ERROR', null);
      commit('CLEAR_CURRENT_LEVEL_RESULTS');

      try {
        const response = await migrationService.runCurrentLevelDryRun(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errors = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsers: payload.totalUsers ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          errorDetails: errors,
        };
        commit('SET_CURRENT_LEVEL_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run current level dry run';
        commit('SET_CURRENT_LEVEL_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_CURRENT_LEVEL_LOADING', false);
      }
    },

    /**
     * Run current level migration (persists to DB)
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug
     */
    async runCurrentLevelMigration({ commit, state }, tenantSlug = null) {
      if (currentLevelRequestInFlight) {
        return state.currentLevelMigrationResults;
      }
      currentLevelRequestInFlight = true;
      commit('SET_CURRENT_LEVEL_LOADING', true);
      commit('SET_CURRENT_LEVEL_ERROR', null);

      try {
        const response = await migrationService.runCurrentLevelMigration(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errors = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsers: payload.totalUsers ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          errorDetails: errors,
        };
        commit('SET_CURRENT_LEVEL_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run current level migration';
        commit('SET_CURRENT_LEVEL_ERROR', errorMessage);
        throw error;
      } finally {
        currentLevelRequestInFlight = false;
        commit('SET_CURRENT_LEVEL_LOADING', false);
      }
    },

    /**
     * Clear current level migration results
     */
    clearCurrentLevelResults({ commit }) {
      commit('CLEAR_CURRENT_LEVEL_RESULTS');
    },
    async runExternalEvaluationEnabledToSchemasDryRun({ commit }, tenantSlug = null) {
      commit('SET_EE_SOT_LOADING', true);
      commit('SET_EE_SOT_ERROR', null);
      commit('CLEAR_EE_SOT_RESULTS');

      try {
        const response = await migrationService.runExternalEvaluationEnabledToSchemasDryRun(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errors = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsersScanned: payload.totalUsersScanned ?? 0,
          eeSchemaCount: payload.eeSchemaCount ?? 0,
          granted: payload.granted ?? 0,
          unsetOnly: payload.unsetOnly ?? 0,
          skipped: payload.skipped ?? 0,
          blockedNoSchemas: payload.blockedNoSchemas ?? 0,
          errors: payload.errors ?? 0,
          assessmentsUntouched: payload.assessmentsUntouched !== false,
          errorDetails: errors,
        };
        commit('SET_EE_SOT_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message
          || error.message
          || 'Failed to run EE SoT dry run';
        commit('SET_EE_SOT_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_EE_SOT_LOADING', false);
      }
    },

    async runExternalEvaluationEnabledToSchemasMigration({ commit, state }, tenantSlug = null) {
      if (eeSotRequestInFlight) {
        return state.eeSotMigrationResults;
      }
      eeSotRequestInFlight = true;
      commit('SET_EE_SOT_LOADING', true);
      commit('SET_EE_SOT_ERROR', null);

      try {
        const response = await migrationService.runExternalEvaluationEnabledToSchemasMigration(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errors = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsersScanned: payload.totalUsersScanned ?? 0,
          eeSchemaCount: payload.eeSchemaCount ?? 0,
          granted: payload.granted ?? 0,
          unsetOnly: payload.unsetOnly ?? 0,
          skipped: payload.skipped ?? 0,
          blockedNoSchemas: payload.blockedNoSchemas ?? 0,
          errors: payload.errors ?? 0,
          assessmentsUntouched: payload.assessmentsUntouched !== false,
          errorDetails: errors,
        };
        commit('SET_EE_SOT_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message
          || error.message
          || 'Failed to run EE SoT migration';
        commit('SET_EE_SOT_ERROR', errorMessage);
        throw error;
      } finally {
        eeSotRequestInFlight = false;
        commit('SET_EE_SOT_LOADING', false);
      }
    },

    clearExternalEvaluationEnabledToSchemasResults({ commit }) {
      commit('CLEAR_EE_SOT_RESULTS');
    },


    /**
     * Run dev tip dimension rotation migration dry run (preview only)
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug
     */
    async runDevTipDimensionRotationDryRun({ commit }, tenantSlug = null) {
      commit('SET_DEV_TIP_ROTATION_LOADING', true);
      commit('SET_DEV_TIP_ROTATION_ERROR', null);
      commit('CLEAR_DEV_TIP_ROTATION_RESULTS');

      try {
        const response = await migrationService.runDevTipDimensionRotationDryRun(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsersMissing: payload.totalUsersMissing ?? 0,
          usersMigrated: payload.usersMigrated ?? 0,
          rotationEntriesAdded: payload.rotationEntriesAdded ?? 0,
          errors: payload.errors ?? 0,
          errorDetails,
        };
        commit('SET_DEV_TIP_ROTATION_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run dev tip dimension rotation dry run';
        commit('SET_DEV_TIP_ROTATION_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_DEV_TIP_ROTATION_LOADING', false);
      }
    },

    /**
     * Run dev tip dimension rotation migration (persists to DB)
     * @param {Object} context - Vuex context
     * @param {string|null} tenantSlug - Optional tenant slug
     */
    async runDevTipDimensionRotationMigration({ commit, state }, tenantSlug = null) {
      if (devTipRotationRequestInFlight) {
        return state.devTipRotationMigrationResults;
      }
      devTipRotationRequestInFlight = true;
      commit('SET_DEV_TIP_ROTATION_LOADING', true);
      commit('SET_DEV_TIP_ROTATION_ERROR', null);

      try {
        const response = await migrationService.runDevTipDimensionRotationMigration(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalUsersMissing: payload.totalUsersMissing ?? 0,
          usersMigrated: payload.usersMigrated ?? 0,
          rotationEntriesAdded: payload.rotationEntriesAdded ?? 0,
          errors: payload.errors ?? 0,
          errorDetails,
        };
        commit('SET_DEV_TIP_ROTATION_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run dev tip dimension rotation migration';
        commit('SET_DEV_TIP_ROTATION_ERROR', errorMessage);
        throw error;
      } finally {
        devTipRotationRequestInFlight = false;
        commit('SET_DEV_TIP_ROTATION_LOADING', false);
      }
    },

    /**
     * Clear dev tip dimension rotation migration results
     */
    clearDevTipDimensionRotationResults({ commit }) {
      commit('CLEAR_DEV_TIP_ROTATION_RESULTS');
    },

    async runScheduleWallClockDryRun({ commit }, tenantSlug = null) {
      commit('SET_SCHEDULE_WALL_CLOCK_LOADING', true);
      commit('SET_SCHEDULE_WALL_CLOCK_ERROR', null);
      commit('CLEAR_SCHEDULE_WALL_CLOCK_RESULTS');

      try {
        const response = await migrationService.runScheduleWallClockDryRun(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalSchemas: payload.totalSchemas ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          errorDetails,
          changes: Array.isArray(payload.changes) ? payload.changes : [],
        };
        commit('SET_SCHEDULE_WALL_CLOCK_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run schedule wall-clock dry run';
        commit('SET_SCHEDULE_WALL_CLOCK_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_SCHEDULE_WALL_CLOCK_LOADING', false);
      }
    },

    async runScheduleWallClockMigration({ commit, state }, tenantSlug = null) {
      if (scheduleWallClockRequestInFlight) {
        return state.scheduleWallClockMigrationResults;
      }
      scheduleWallClockRequestInFlight = true;
      commit('SET_SCHEDULE_WALL_CLOCK_LOADING', true);
      commit('SET_SCHEDULE_WALL_CLOCK_ERROR', null);

      try {
        const response = await migrationService.runScheduleWallClockMigration(tenantSlug);
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalSchemas: payload.totalSchemas ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          errorDetails,
          changes: Array.isArray(payload.changes) ? payload.changes : [],
          completedAt: new Date().toISOString(),
        };
        commit('SET_SCHEDULE_WALL_CLOCK_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message
          || error.message
          || 'Failed to run schedule wall-clock migration';
        commit('SET_SCHEDULE_WALL_CLOCK_ERROR', errorMessage);
        throw error;
      } finally {
        scheduleWallClockRequestInFlight = false;
        commit('SET_SCHEDULE_WALL_CLOCK_LOADING', false);
      }
    },

    clearScheduleWallClockResults({ commit }) {
      commit('CLEAR_SCHEDULE_WALL_CLOCK_RESULTS');
    },

    async runKssScheduleTimesDryRun({ commit }) {
      commit('SET_KSS_SCHEDULE_TIMES_LOADING', true);
      commit('SET_KSS_SCHEDULE_TIMES_ERROR', null);
      commit('CLEAR_KSS_SCHEDULE_TIMES_RESULTS');

      try {
        const response = await migrationService.runKssScheduleTimesDryRun();
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalSeries: payload.totalSeries ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          deletedScheduled: payload.deletedScheduled ?? 0,
          createdScheduled: payload.createdScheduled ?? 0,
          errorDetails,
          changes: Array.isArray(payload.changes) ? payload.changes : [],
        };
        commit('SET_KSS_SCHEDULE_TIMES_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run KSS schedule-times dry run';
        commit('SET_KSS_SCHEDULE_TIMES_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_KSS_SCHEDULE_TIMES_LOADING', false);
      }
    },

    async runKssScheduleTimesMigration({ commit, state }) {
      if (kssScheduleTimesRequestInFlight) {
        return state.kssScheduleTimesMigrationResults;
      }
      kssScheduleTimesRequestInFlight = true;
      commit('SET_KSS_SCHEDULE_TIMES_LOADING', true);
      commit('SET_KSS_SCHEDULE_TIMES_ERROR', null);

      try {
        const response = await migrationService.runKssScheduleTimesMigration();
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const errorDetails = Array.isArray(payload.errorDetails) ? payload.errorDetails : [];
        const result = {
          totalSeries: payload.totalSeries ?? 0,
          migrated: payload.migrated ?? 0,
          skipped: payload.skipped ?? 0,
          errors: payload.errors ?? 0,
          deletedScheduled: payload.deletedScheduled ?? 0,
          createdScheduled: payload.createdScheduled ?? 0,
          errorDetails,
          changes: Array.isArray(payload.changes) ? payload.changes : [],
          completedAt: new Date().toISOString(),
        };
        commit('SET_KSS_SCHEDULE_TIMES_MIGRATION_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message
          || error.message
          || 'Failed to run KSS schedule-times migration';
        commit('SET_KSS_SCHEDULE_TIMES_ERROR', errorMessage);
        throw error;
      } finally {
        kssScheduleTimesRequestInFlight = false;
        commit('SET_KSS_SCHEDULE_TIMES_LOADING', false);
      }
    },

    clearKssScheduleTimesResults({ commit }) {
      commit('CLEAR_KSS_SCHEDULE_TIMES_RESULTS');
    },

    async runFeaturesMigrateDryRun({ commit }) {
      commit('SET_FEATURE_MIGRATE_LOADING', true);
      commit('SET_FEATURE_MIGRATE_ERROR', null);
      commit('CLEAR_FEATURE_MIGRATE_RESULTS');

      try {
        const response = await migrationService.runFeaturesMigrateDryRun();
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const result = {
          dryRun: payload.dryRun !== false,
          totalRows: payload.totalRows ?? 0,
          duplicateRowsByType: payload.duplicateRowsByType ?? 0,
          duplicateRowsDeleted: payload.duplicateRowsDeleted ?? 0,
          orphanParentRefsToClear: payload.orphanParentRefsToClear ?? 0,
          orphanParentRefsCleared: payload.orphanParentRefsCleared ?? 0,
          rowsNormalized: payload.rowsNormalized ?? 0,
          legacyFieldsStrippedFromDocs: payload.legacyFieldsStrippedFromDocs ?? 0,
          errors: Array.isArray(payload.errors) ? payload.errors : [],
        };
        commit('SET_FEATURE_MIGRATE_DRY_RUN_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run features migration dry run';
        commit('SET_FEATURE_MIGRATE_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_FEATURE_MIGRATE_LOADING', false);
      }
    },

    async runFeaturesMigrate({ commit, state }) {
      if (featureMigrateRequestInFlight) {
        return state.featureMigrateApplyResults;
      }
      featureMigrateRequestInFlight = true;
      commit('SET_FEATURE_MIGRATE_LOADING', true);
      commit('SET_FEATURE_MIGRATE_ERROR', null);

      try {
        const response = await migrationService.runFeaturesMigrate();
        const raw = response?.data?.data ?? response?.data ?? {};
        const payload = raw?.data ?? raw;
        const result = {
          dryRun: payload.dryRun === true,
          totalRows: payload.totalRows ?? 0,
          duplicateRowsByType: payload.duplicateRowsByType ?? 0,
          duplicateRowsDeleted: payload.duplicateRowsDeleted ?? 0,
          orphanParentRefsToClear: payload.orphanParentRefsToClear ?? 0,
          orphanParentRefsCleared: payload.orphanParentRefsCleared ?? 0,
          rowsNormalized: payload.rowsNormalized ?? 0,
          legacyFieldsStrippedFromDocs: payload.legacyFieldsStrippedFromDocs ?? 0,
          errors: Array.isArray(payload.errors) ? payload.errors : [],
        };
        commit('SET_FEATURE_MIGRATE_APPLY_RESULTS', result);
        return result;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run features migration';
        commit('SET_FEATURE_MIGRATE_ERROR', errorMessage);
        throw error;
      } finally {
        featureMigrateRequestInFlight = false;
        commit('SET_FEATURE_MIGRATE_LOADING', false);
      }
    },

    clearFeatureMigrateResults({ commit }) {
      commit('CLEAR_FEATURE_MIGRATE_RESULTS');
    },

    async runTenantRolesDryRun({ commit }) {
      commit('SET_TENANT_ROLES_LOADING', true);
      commit('SET_TENANT_ROLES_ERROR', null);
      commit('CLEAR_TENANT_ROLES_RESULTS');

      try {
        const response = await migrationService.runTenantRolesDryRun();
        const payload = response?.data ?? {};
        commit('SET_TENANT_ROLES_DRY_RUN_RESULTS', payload);
        return payload;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run tenant roles dry run';
        commit('SET_TENANT_ROLES_ERROR', errorMessage);
        throw error;
      } finally {
        commit('SET_TENANT_ROLES_LOADING', false);
      }
    },

    async runTenantRolesMigration({ commit, state }) {
      if (tenantRolesRequestInFlight) {
        return state.tenantRolesMigrationResults;
      }
      tenantRolesRequestInFlight = true;
      commit('SET_TENANT_ROLES_LOADING', true);
      commit('SET_TENANT_ROLES_ERROR', null);

      try {
        const response = await migrationService.runTenantRolesMigration();
        const payload = response?.data ?? {};
        commit('SET_TENANT_ROLES_MIGRATION_RESULTS', payload);
        return payload;
      } catch (error) {
        const errorMessage =
          error.response?.data?.message || error.message || 'Failed to run tenant roles migration';
        commit('SET_TENANT_ROLES_ERROR', errorMessage);
        throw error;
      } finally {
        tenantRolesRequestInFlight = false;
        commit('SET_TENANT_ROLES_LOADING', false);
      }
    },

    clearTenantRolesResults({ commit }) {
      commit('CLEAR_TENANT_ROLES_RESULTS');
    },
  },

  getters: {
    isLoading: (state) => state.loading,
    error: (state) => state.error,
    dryRunResults: (state) => state.dryRunResults,
    migrationResults: (state) => state.migrationResults,
    hasDryRunResults: (state) => !!state.dryRunResults,
    hasMigrationResults: (state) => !!state.migrationResults,
    isCurrentLevelLoading: (state) => state.currentLevelLoading,
    currentLevelError: (state) => state.currentLevelError,
    currentLevelDryRunResults: (state) => state.currentLevelDryRunResults,
    currentLevelMigrationResults: (state) => state.currentLevelMigrationResults,
    hasCurrentLevelResults: (state) =>
      !!state.currentLevelDryRunResults || !!state.currentLevelMigrationResults,
    isEeSotLoading: (state) => state.eeSotLoading,
    eeSotError: (state) => state.eeSotError,
    eeSotDryRunResults: (state) => state.eeSotDryRunResults,
    eeSotMigrationResults: (state) => state.eeSotMigrationResults,
    hasEeSotResults: (state) =>
      !!state.eeSotDryRunResults || !!state.eeSotMigrationResults,
    isDevTipRotationLoading: (state) => state.devTipRotationLoading,
    devTipRotationError: (state) => state.devTipRotationError,
    devTipRotationDryRunResults: (state) => state.devTipRotationDryRunResults,
    devTipRotationMigrationResults: (state) => state.devTipRotationMigrationResults,
    hasDevTipRotationResults: (state) =>
      !!state.devTipRotationDryRunResults || !!state.devTipRotationMigrationResults,
    isScheduleWallClockLoading: (state) => state.scheduleWallClockLoading,
    scheduleWallClockError: (state) => state.scheduleWallClockError,
    scheduleWallClockDryRunResults: (state) => state.scheduleWallClockDryRunResults,
    scheduleWallClockMigrationResults: (state) => state.scheduleWallClockMigrationResults,
    hasScheduleWallClockResults: (state) =>
      !!state.scheduleWallClockDryRunResults || !!state.scheduleWallClockMigrationResults,
    isKssScheduleTimesLoading: (state) => state.kssScheduleTimesLoading,
    kssScheduleTimesError: (state) => state.kssScheduleTimesError,
    kssScheduleTimesDryRunResults: (state) => state.kssScheduleTimesDryRunResults,
    kssScheduleTimesMigrationResults: (state) => state.kssScheduleTimesMigrationResults,
    hasKssScheduleTimesResults: (state) =>
      !!state.kssScheduleTimesDryRunResults || !!state.kssScheduleTimesMigrationResults,
    featureMigrateLoading: (state) => state.featureMigrateLoading,
    featureMigrateError: (state) => state.featureMigrateError,
    featureMigrateDryRunResults: (state) => state.featureMigrateDryRunResults,
    featureMigrateApplyResults: (state) => state.featureMigrateApplyResults,
    hasFeatureMigrateDryRunResults: (state) => !!state.featureMigrateDryRunResults,
    hasFeatureMigrateApplyResults: (state) => !!state.featureMigrateApplyResults,
    hasFeatureMigrateResults: (state) =>
      !!state.featureMigrateDryRunResults || !!state.featureMigrateApplyResults,
    isTenantRolesLoading: (state) => state.tenantRolesLoading,
    tenantRolesError: (state) => state.tenantRolesError,
    tenantRolesDryRunResults: (state) => state.tenantRolesDryRunResults,
    tenantRolesMigrationResults: (state) => state.tenantRolesMigrationResults,
    hasTenantRolesResults: (state) =>
      !!state.tenantRolesDryRunResults || !!state.tenantRolesMigrationResults,
  },
};
